import { httpClient } from './axiosClients';

export function getUser() {
  return httpClient.get('/api/user');
}

export function getIsAuthenticated() {
  return httpClient.get('/api/wc/is-authenticated');
}

export function getCities({ params }) {
  return httpClient.get('/api/city', { params });
}

export function getPropertyTypes({ params }) {
  return httpClient.get('/api/property-types', { params });
}

export function getSocialLoginUrls(params) {
  return httpClient.get('/api/social-login-urls', { params });
}

export function createCallMeBackRequest(payload) {
  return httpClient.post('/api/leads/call-me-back', payload);
}

export function getSurvey(surveyId) {
  return httpClient.get(`/api/surveys/${surveyId}`);
}

export function updateSurvey(surveyId, payload) {
  return httpClient.patch(`/api/surveys/${surveyId}`, payload);
}

export function uploadPicture(picture) {
  /*
    picture is a form data object containing the file to upload
    Response is an object with the following structure:
    {
      "success": true,
      "url": "url",
      "key": "key"
    }
  */
  return httpClient.post('/api/wc/pictures/upload', picture);
}

export function uploadFile(file) {
  /*
    file is a form data object containing the file to upload
    Response is an object with the following structure:
    {
      "success": true,
      "url": "url",
      "key": "key"
    }
  */
  return httpClient.post('/api/wc/files/upload', file);
}
